import React, { Component } from "react";
import { TextField } from '@material-ui/core';
import * as FontAwesome from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { EyeItalic } from './styles';

class LoginPasswordTextField extends Component {

    state = {
        type: 'password',
        icon: faEyeSlash
    }

    clickEye = e => {
        if (this.state.type === 'password') {
            this.setState({ type: 'text', icon: faEye });
            return;
        }
        
        this.setState({ type: 'password', icon: faEyeSlash });
    }

    render () {
        return (
            <div>
                <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name={this.props.name}
                    label={this.props.label}
                    type={this.state.type}
                    autoComplete="off" 
                    onChange={e => this.props.onChange(e)}
                    error={this.props.error}/>
                <EyeItalic onClick={this.clickEye} >
                    <FontAwesome.FontAwesomeIcon icon={this.state.icon} />
                </EyeItalic>
            </div>
        )
    }
}

export default LoginPasswordTextField;